import _extends from '../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.find-index.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import React, { useState, useRef, useEffect } from 'react';
import './style/index.less.js';
import img from '../assets/dateRangePicker.png.js';
import { isDate, isFunction, isString } from 'lodash';
import { DatePickerView, Popup, Tabs, Swiper } from 'antd-mobile';
import dayjs from 'dayjs';
import useLanguage from '../hooks/useLangugle/index.js';
import classNames from 'classnames';

var TiDateRangePicker = function TiDateRangePicker(props) {
  var _a;
  var _b = props.value,
    value = _b === void 0 ? [] : _b,
    onChange = props.onChange,
    _c = props.format,
    format = _c === void 0 ? 'YYYY-MM-DD' : _c,
    disabled = props.disabled,
    precision = props.precision,
    max = props.max,
    min = props.min,
    renderLabel = props.renderLabel;
  var locale = useLanguage('DateRangePicker');
  var commonLocale = useLanguage('Common');
  var _d = useState(),
    innerStartTime = _d[0],
    setInnerStartTime = _d[1];
  var _e = useState(),
    innerEndTime = _e[0],
    setInnerEndTime = _e[1];
  var _f = useState(false),
    visible = _f[0],
    setVisible = _f[1];
  var swiperRef = useRef(null);
  var _g = useState(0),
    activeIndex = _g[0],
    setActiveIndex = _g[1];
  var commonProps = {
    precision: precision,
    max: max,
    min: min,
    renderLabel: renderLabel
  };
  var startTimeValue = value.length >= 1 ? value[0] : undefined;
  var endTimeValue = value.length >= 2 ? value[1] : undefined;
  useEffect(function () {
    if (visible) {
      setInnerStartTime(startTimeValue);
      setInnerEndTime(endTimeValue);
    }
  }, [visible]);
  var triggerOnChange = function triggerOnChange(dateRange) {
    if (isFunction(onChange)) {
      onChange(dateRange);
    }
  };
  var onOpen = function onOpen() {
    if (disabled) {
      return;
    }
    setVisible(true);
  };
  var onClose = function onClose() {
    setVisible(false);
    setActiveIndex(0);
  };
  var onConfirm = function onConfirm() {
    if (activeIndex === 0) {
      handleTabsChange('end');
      return;
    }
    if (activeIndex === 1) {
      triggerOnChange([innerStartTime, innerEndTime]);
      onClose();
      return;
    }
  };
  var onStartTimeChange = function onStartTimeChange(start) {
    setInnerStartTime(start);
  };
  var onEndTimeChange = function onEndTimeChange(end) {
    setInnerEndTime(end);
  };
  var tabs = [{
    key: 'start',
    title: locale['startTime'],
    content: /*#__PURE__*/React.createElement(DatePickerView, _extends({}, commonProps, {
      value: innerStartTime,
      onChange: onStartTimeChange
    }))
  }, {
    key: 'end',
    title: locale['endTime'],
    content: /*#__PURE__*/React.createElement(DatePickerView, _extends({}, commonProps, {
      value: innerEndTime,
      onChange: onEndTimeChange,
      min: innerStartTime
    }))
  }];
  var handleFormat = function handleFormat(date) {
    if (isFunction(format)) {
      return format(date);
    }
    if (isString(format)) {
      return dayjs(date).format(format);
    }
    return '-';
  };
  var handleTabsChange = function handleTabsChange(key) {
    var _a;
    var index = tabs.findIndex(function (item) {
      return item.key === key;
    });
    setActiveIndex(index);
    (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.swipeTo(index);
  };
  var triggerStyle = {
    '--ti-placeholder-color': '#9EA1A7'
  };
  var triggerCls = classNames((_a = {}, _a['ti-date-range-picker-trigger'] = true, _a['ti-date-range-picker-trigger-disabled'] = disabled, _a));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: triggerCls,
    style: triggerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-time",
    onClick: onOpen
  }, isDate(startTimeValue) ? /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-time-content"
  }, handleFormat(startTimeValue)) : /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-time-placeholder"
  }, locale['startTime']), /*#__PURE__*/React.createElement("img", {
    className: "ti-date-range-picker-time-icon",
    src: img
  })), /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-middle"
  }, "-"), /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-time",
    onClick: onOpen
  }, isDate(endTimeValue) ? /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-time-content"
  }, handleFormat(endTimeValue)) : /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-time-placeholder"
  }, locale['endTime']), /*#__PURE__*/React.createElement("img", {
    className: "ti-date-range-picker-time-icon",
    src: img
  }))), /*#__PURE__*/React.createElement(Popup, {
    className: "ti-date-range-picker-popup",
    visible: visible,
    onMaskClick: onClose,
    destroyOnClose: true,
    onClose: onClose,
    bodyStyle: {
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      minHeight: '40vh'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-popup-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-header-button-left",
    onClick: onClose
  }, commonLocale['cancel']), /*#__PURE__*/React.createElement("div", {
    className: "popup-header-middle"
  }, locale['timeRange']), /*#__PURE__*/React.createElement("div", {
    className: "popup-header-button-right",
    onClick: onConfirm
  }, activeIndex === 0 ? commonLocale['next'] : commonLocale['confirm'])), /*#__PURE__*/React.createElement("div", {
    className: "ti-date-range-picker-popup-content"
  }, /*#__PURE__*/React.createElement(Tabs, {
    stretch: false,
    activeKey: tabs[activeIndex].key,
    onChange: handleTabsChange,
    style: {
      '--title-font-size': '14px'
    }
  }, tabs.map(function (item) {
    return /*#__PURE__*/React.createElement(Tabs.Tab, {
      title: item.title,
      key: item.key,
      style: {
        marginRight: '24px'
      }
    });
  })), /*#__PURE__*/React.createElement(Swiper, {
    direction: "horizontal",
    loop: true,
    indicator: function indicator() {
      return null;
    },
    ref: swiperRef,
    defaultIndex: activeIndex,
    onIndexChange: function onIndexChange(index) {
      setActiveIndex(index);
    }
  }, tabs.map(function (x) {
    return /*#__PURE__*/React.createElement(Swiper.Item, {
      key: x.key
    }, /*#__PURE__*/React.createElement("div", null, x.content));
  })))));
};

export { TiDateRangePicker as default };
